import useMutation from "src/hooks/useMutation";

function useBrandUpdate(id) {
  return useMutation({
    path: `/api/v1/brands/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/brands`,
      shouldRevalidate: true,
    },
  });
}

export default useBrandUpdate;
